export const techSkills = [
  {
    section: "Cloud & Integrations",
    skills: [
      { title: "AWS S3" },
      { title: "AWS Lambda" },
      { title: "AWS EC2" },
      { title: "Azure" },
      { title: "WhatsApp Business API" },
      { title: "Zoho CRM" },
      { title: "Cashfree" },
      { title: "Git" },
      { title: "Docker" },
      { title: "CI/CD Pipeline" },
      { title: "Ngnix" },
      { title: "Third-Party API Integrations" },
    ],
  },
  {
    section: "Backend",
    skills: [
      { title: "Node.js" },
      { title: "NestJS" },
      { title: "Express.js" },
      { title: "Fast API" },
      { title: "Flask" },
      { title: "REST APIs" },
      { title: "JWT" },
      { title: "Passport" },
      { title: "RBAC" },
      { title: "Socket.IO" },
      { title: "OAuth2" },
    ],
  },
  {
    section: "AI & Search",
    skills: [
      { title: "OpenAI APIs" },
      { title: "Large Language Models (LLMs)" },
      { title: "MCP Server" },
      { title: "Vector Embeddings" },
      { title: "Retrieval Systems" },
      { title: "Semantic Search" },
      { title: "Vector Search" },
      { title: "Elasticsearch" },
      { title: "Prompt Engineering" },
      { title: "Generative AI" },
      { title: "AI Agents" },
    ],
  },
  {
    section: "Core Competencies",
    skills: [
      { title: "System Design" },
      { title: "Distributed Systems" },
      { title: "Microservices" },
      { title: "Scalable Architecture" },
      { title: "Performance Optimization" },
      { title: "Database Optimization" },
      { title: "API Design" }
    ],
  },
  {
    section: "Caching & Queues",
    skills: [
      { title: "Redis" },
      { title: "Bull Queue" },
      { title: "Background Jobs" },
      { title: "Queue-Based Processing" },
      { title: "Event-Driven Architecture" },
      { title: "Pub/Sub" },
      { title: "Kafka" }
    ],
  },
  {
    section: "Frontend",
    skills: [
      { title: "React.js" },
      { title: "Next.js" },
      { title: "Redux" },
      { title: "Tanstack Query" },
      { title: "Vue.js" },
      { title: "AngularJS" }
    ],
  },
  {
    section: "Databases",
    skills: [
      { title: "MongoDB" },
      { title: "MySQL" },
      { title: "Qdrant Vector Database" },
      { title: "PostgreSQL" },
      { title: "DynamoDB" }
    ],
  },
  {
    section: "Languages",
    skills: [
      { title: "JavaScript" },
      { title: "TypeScript" },
      { title: "Python" }
    ],
  }
];
